import React, { useEffect, useState } from 'react';
import api from '../services/apiService';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Select from 'react-select';
import moment from 'moment';

const InterimList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const urlInterimNumber = urlParams.get('InterimNumber');

  // State
  const [Interims, setInterims] = useState([]);
  const [filters, setFilters] = useState(() => {
    const stored = localStorage.getItem('InterimListFilters');
     // Immer zuerst als Objekt parsen (oder leeres Objekt, falls nichts vorhanden)
  const storedParsed = stored ? JSON.parse(stored) : {};

  const init = {
    interimNumber: null,
    referenceNumber: null,
    customer: null,
    contact: null,
    date: null,
    status: null,
    orderNumber: storedParsed.orderNumber || null, // <-- Zugriff jetzt sicher!
    smartRental: null,
  };
  if (urlInterimNumber) {
    init.InterimNumber = {
      value: urlInterimNumber,
      label: urlInterimNumber,
    };
  }
  return init;
});

  useEffect(() => {
    localStorage.setItem('InterimListFilters', JSON.stringify(filters));
    setCurrentPage(1);
  }, [filters]);

  // Filteroptionen
  const [serverFilterOptions, setServerFilterOptions] = useState({
    interimNumbers: [],
    referenceNumbers: [],
    customers: [],
    contacts: [],
    dates: [],
    statuses: [],
    orderNumbers: [],
    smartRentalOptions: [],
  });
  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const response = await api.get('/interims/filter-options');
        setServerFilterOptions(response.data);
      } catch (error) {
        console.error('Fehler beim Laden der Filteroptionen:', error);
      }
    };
    fetchFilterOptions();
  }, []);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 25;

  const buildQuery = () => {
    const params = new URLSearchParams();
    params.append('limit', limit);
    params.append('page', currentPage);
    if (filters.interimNumber) {
      params.append('interimNumber', filters.interimNumber.value);
    }
    if (filters.referenceNumber) {
      params.append('referenceNumber', filters.referenceNumber.value);
    }
    if (filters.customer) {
      params.append('customer', filters.customer.value);
    }
    if (filters.contact) {
      params.append('contact', filters.contact.value);
    }
    if (filters.date) {
      params.append('date', filters.date.value);
    }
    if (filters.status) {
      params.append('status', filters.status.value);
    }
    if (filters.smartRental) {
      params.append('smartRental', filters.smartRental.value);
    }
     if (filters.orderNumber) {
    params.append('orderNumber', filters.orderNumber.value);
  }
    return params.toString() ? `?${params.toString()}` : '';
  };

  useEffect(() => {
    const fetchInterims = async () => {
      try {
        const query = buildQuery();
        const response = await api.get(`/interims/list${query}`);
        setInterims(response.data.data);
        setTotalPages(response.data.pages);
      } catch (error) {
        console.error('Fehler beim Abrufen der Zwischenabrechnungen:', error);
      }
    };
    fetchInterims();
  }, [filters, currentPage]);

  console.log("Interims vom Server:", Interims);

  // Datum formatieren
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  // PDF
  const handleViewPDF = (InterimId) => {
    const pdfUrl = `${api.defaults.baseURL}/documents/interim-invoice/${InterimId}/pdf`;
    window.open(pdfUrl, '_blank');
  };

  // Löschen
  const deleteInterim = (id) => {
    if (window.confirm('Möchten Sie diese Zwischenabrechnung wirklich löschen?')) {
      api.delete(`/interims/${id}`)
        .then(() => {
          setInterims(prev => prev.filter(inv => inv.id !== id));
          alert('Zwischenabrechnung erfolgreich gelöscht!');
        })
        .catch(error => console.error('Fehler beim Löschen:', error));
    }
  };

  // Draft erstellen
  const createDraftInterim = async () => {
    try {
      const payload = { customerId: 1 }; // Beispielhafte Kunden-ID
      const response = await api.post('/interims/draft', payload);
      const { editUrl } = response.data;
      navigate(editUrl);
    } catch (error) {
      console.error('Fehler beim Erstellen des Entwurfs!', error);
      alert('Fehler beim Erstellen des Entwurfs!');
    }
  };

  // Mail senden
  const sendInterimMail = async (InterimId) => {
    try {
      await api.post(`/documents/interim-invoice/${InterimId}/mail`);
      alert('✅ Zwischenabrechnung erfolgreich gemailt!');
    } catch (error) {
      console.error('Fehler beim Mailen der Zwischenabrechnung:', error);
      alert('Fehler beim Mailen!');
    }
  };

  const handleCreateInterimInvoice = async (id) => {
  try {
    await api.post(`/invoices/duplicate-interim/${id}`, { invoiceType: 'interimInvoice' });
    alert('Zwischenabrechnung-Rechnung erfolgreich erzeugt!');
  } catch (err) {
    if (
      err.response &&
      err.response.status === 400 &&
      err.response.data &&
      err.response.data.invoiceId
    ) {
      alert('Für diese Zwischenabrechnung existiert bereits eine Rechnung.');
    } else {
      alert('Fehler beim Erzeugen der Rechnung: ' + (err.response?.data?.error || err.message));
    }
  }
};

const handleCreateFinalInvoice = async (id) => {
  try {
    await api.post(`/invoices/duplicate-interim/${id}`, { invoiceType: 'finalInvoice' });
    alert('Finalrechnung erfolgreich erzeugt!');
  } catch (err) {
    if (
      err.response &&
      err.response.status === 400 &&
      err.response.data &&
      err.response.data.invoiceId
    ) {
      alert('Für diese Zwischenabrechnung existiert bereits eine Rechnung.');
    } else {
      alert('Fehler beim Erzeugen der Finalrechnung: ' + (err.response?.data?.error || err.message));
    }
  }
};



  return (
    <div className="interim-invoice-list">
      <Helmet>
        <title>Zwischenabrechnungen</title>
        <meta name="description" content="Zwischenabrechnungsliste" />
      </Helmet>
      <h1>Zwischenabrechnungen</h1>

      {/* Button zum Erstellen einer neuen Zwischenabrechnung */}
      

      {/* Filterleiste */}
      <div style={{ marginBottom: '20px' }}>
        <h3>Filter</h3>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
          gap: '10px',
          width: '100%'
        }}>
          <Select
  options={
    (serverFilterOptions.interimNumbers || [])
      .slice() // Kopie für Sortierung
      .sort((a, b) => {
        // Numerisch absteigend, unabhängig davon, ob als String oder Number gespeichert
        const numA = Number(a);
        const numB = Number(b);
        // Wenn Präfixe wie "AB0015", "AB0016" → auf numerischen Teil prüfen:
        if (isNaN(numA) || isNaN(numB)) {
          // Alphanumerisch absteigend, falls keine reine Nummer
          return String(b).localeCompare(String(a), 'de', { numeric: true });
        }
        return numB - numA;
      })
      .map(v => ({ value: v, label: v }))
  }
  placeholder="Z-Abrechnungs.nr."
  isClearable
  value={filters.interimNumber}
  onChange={selected => setFilters({ ...filters, interimNumber: selected })}
/>

          <Select
            options={serverFilterOptions.referenceNumbers.map(val => ({ value: val, label: val }))}
            placeholder="Bestellnummer"
            isClearable
            value={filters.referenceNumber}
            onChange={selected => setFilters({ ...filters, referenceNumber: selected })}
          />
          <Select
  options={
    (serverFilterOptions.orderNumbers || [])
      .slice()
      .sort((a, b) => {
        const aNum = parseInt(a.replace(/\D/g, ''), 10);
        const bNum = parseInt(b.replace(/\D/g, ''), 10);
        if (!isNaN(aNum) && !isNaN(bNum)) {
          return bNum - aNum;
        }
        return b > a ? 1 : -1;
      })
      .map(v => ({ value: v, label: v }))
  }
  placeholder="Auftragsnr."
  isClearable
  value={filters.orderNumber}
  onChange={sel => setFilters(f => ({ ...f, orderNumber: sel }))}
/>
          <Select
            options={serverFilterOptions.customers.map(val => ({ value: val, label: val }))}
            placeholder="Kunde"
            isClearable
            value={filters.customer}
            onChange={selected => setFilters({ ...filters, customer: selected })}
          />
          <Select
            options={serverFilterOptions.contacts.map(val => ({ value: val, label: val }))}
            placeholder="Besteller"
            isClearable
            value={filters.contact}
            onChange={selected => setFilters({ ...filters, contact: selected })}
          />
          <Select
            styles={{ menu: provided => ({ ...provided, zIndex: 11 }) }}
            options={serverFilterOptions.dates.map(val => ({ value: val, label: val }))}
            placeholder="Datum"
            isClearable
            value={filters.date}
            onChange={selected => setFilters({ ...filters, date: selected })}
          />
          <Select
            options={serverFilterOptions.statuses.map(val => ({ value: val, label: val }))}
            placeholder="Status"
            isClearable
            value={filters.status}
            onChange={selected => setFilters({ ...filters, status: selected })}
          />
          <Select
  options={(serverFilterOptions.smartRentalOptions || []).map(val => ({
    value: val.toString(),
    label: val ? 'Ja' : 'Nein'
  }))}
  placeholder="Smart Rental"
  isClearable
  value={filters.smartRental}
  onChange={sel => setFilters(f => ({ ...f, smartRental: sel }))}
/>
        </div>
      </div>

      {/* Tabelle */}
      {Interims.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nr.</th>
              <th>Bestellnr.</th>
              <th>AuftragNr.</th>
              <th>Kunde</th>
              <th>Besteller</th>
              <th>Datum</th>
              <th>Einsatzort</th>
              <th>Status</th>
              <th>Gesamt netto (€)</th>
              <th>Smart Rental</th>
              <th>Aktionen</th>
              <th>Rechnung</th>
            </tr>
          </thead>
          <tbody>
  {Interims.map(inv => {
    const updatedByValid = !!inv.updatedBy;
    const isFinalInvoiceAction = inv.invoiceActionType === 'finalInvoice';
    return (
      <tr key={inv.id}>
        <td>{inv.id}</td>
        <td>{inv.interimNumber}</td>
        <td>{inv.referenceNumber}</td>
        <td>{inv.order && inv.order.orderNumber ? inv.order.orderNumber : '-'}</td>
        <td>{inv.customer?.company || '-'}</td>
        <td>{inv.contact ? `${inv.contact.contactFirstName} ${inv.contact.contactLastName}` : '-'}</td>
        <td>{formatDate(inv.date)}</td>
        <td>{inv.operationLocation || '-'}</td>
        <td>{inv.status}</td>
        <td>{inv.totalNet?.toFixed(2).replace('.', ',')} €</td>
        <td>{inv.smartRental ? "Ja" : "Nein"}</td>
        <td>
          <div style={{ display: 'flex', gap: '5px' }}>
            <button
              type="button"
              onClick={() => navigate(`/interims/${inv.id}/edit`)}
              style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: '#007bff',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Bearbeiten
            </button>
            <button
              type="button"
              onClick={() => deleteInterim(inv.id)}
              style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: '#dc3545',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Löschen
            </button>
          </div>
        </td>
        <td>
          {inv.invoice ? (
            <span style={{
              color: '#8e24aa',
              borderRadius: 5,
              padding: '5px 10px',
              border: 'none',
              fontWeight: 'bold'
            }}>
              Rechnung erzeugt
            </span>
          ) : updatedByValid ? (
            <div style={{ display: 'flex', gap: '5px' }}>
              <button
                type="button"
                onClick={() => (
                  isFinalInvoiceAction
                    ? handleCreateFinalInvoice(inv.id)
                    : handleCreateInterimInvoice(inv.id)
                )}
                style={{
                  backgroundColor: isFinalInvoiceAction ? '#d84315' : '#8e24aa',
                  color:  '#fff',
                  borderRadius: 5,
                  padding: '5px 10px',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                {isFinalInvoiceAction ? 'Finalrechnung' : 'Zwischenrechnung'}
              </button>
            </div>
          ) : (
            <div style={{ color: '#aaa', fontStyle: 'italic' }}>
              <span>Ausgabe nach Speicherung möglich</span>
            </div>
          )}
        </td>
      </tr>
    );
  })}
</tbody>

        </table>
      ) : (
        <p>Keine Zwischenabrechnungen verfügbar.</p>
      )}

      {/* Pagination */}
      <div style={{ marginTop: '1rem' }}>
        <button
          onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
          disabled={currentPage === 1}
          style={{
            fontSize: '15px',
            padding: '8px 12px',
            backgroundColor:'rgb(155, 155, 155)',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }} 
        >
          Vorherige
        </button>
        <span style={{ margin: '0 1rem' }}>
          Seite {currentPage} von {totalPages}
        </span>
        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage >= totalPages}
          style={{
            fontSize: '15px',
            padding: '8px 12px',
            backgroundColor:'rgb(155, 155, 155)',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }} 
        >
          Nächste
        </button>
      </div>
    </div>
  );
};

export default InterimList;
